export default "__VITE_ASSET__DczJKwQ4__"